const features = [
  {
    icon: "ri-camera-line",
    title: "自动抓取留痕",
    desc: "对目标页面按时间点自动保存只读快照，正文、标题、配图与公开评论尽量完整入档，不修改原页内容。",
    tone: "text-primary-700 bg-primary-100",
    tag: "留痕引擎",
  },
  {
    icon: "ri-history-line",
    title: "逐版本时间线",
    desc: "每个收录页面都有一份可回溯的时间轴，从首次收录到最近一次快照连续排列，切换时间点即可回看任意旧版状态。",
    tone: "text-accent-700 bg-accent-100",
    tag: "时间轴",
  },
  {
    icon: "ri-git-merge-line",
    title: "快照并排对比",
    desc: "任选两个时间点的版本进行左右对照，被增、删、改的段落以颜色高亮，一眼定位删改的具体位置与内容。",
    tone: "text-primary-700 bg-primary-100",
    tag: "Diff 高亮",
  },
  {
    icon: "ri-database-2-line",
    title: "缓存版本还原",
    desc: "原页面被删除或下线时，可直接通过缓存版本读取存档正文，第一时间找回已经消失的原始内容。",
    tone: "text-accent-700 bg-accent-100",
    tag: "离线可读",
  },
  {
    icon: "ri-drag-move-2-line",
    title: "口径变更检测",
    desc: "智能识别同一页面在措辞、数据与立场上的前后变化并给出变化幅度，方便核验发布方是否悄悄修改过表述。",
    tone: "text-secondary-800 bg-secondary-100",
    tag: "变更识别",
  },
  {
    icon: "ri-radar-line",
    title: "批量追溯监控",
    desc: "可将一组页面纳入监控队列持续抓取，任何变动都会生成新快照与变更提醒，适合舆情与内容跟踪场景。",
    tone: "text-secondary-800 bg-secondary-100",
    tag: "订阅监控",
  },
];

export default function Features() {
  return (
    <section id="features" className="w-full scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-xl">
            <p className="text-sm font-medium tracking-wide text-accent-700">CAPABILITY · 核心能力</p>
            <h2 className="mt-3 text-2xl text-foreground-950 md:text-4xl">不只缓存，更能追溯与对比</h2>
            <p className="mt-3 text-sm leading-6 text-foreground-700 md:text-base">
              围绕“吃瓜网页历史快照、缓存版本、存档查看”这一场景，把留痕、还原与对比做成一套连贯的能力。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-600">
            <span className="flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1.5 ring-1 ring-background-200">
              <i className="ri-checkbox-circle-line text-accent-600"></i> 只读留痕
            </span>
            <span className="flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1.5 ring-1 ring-background-200">
              <i className="ri-checkbox-circle-line text-primary-500"></i> 逐点可溯
            </span>
            <span className="flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1.5 ring-1 ring-background-200">
              <i className="ri-checkbox-circle-line text-secondary-600"></i> 对比高亮
            </span>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f, idx) => (
            <article
              key={f.title}
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-200"
            >
              <div className="flex items-start justify-between">
                <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${f.tone}`}>
                  <i className={`${f.icon} text-2xl`}></i>
                </span>
                <span className="font-heading text-4xl text-background-300 group-hover:text-primary-200">
                  {String(idx + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-5 text-lg text-foreground-950">{f.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-6 text-foreground-700">{f.desc}</p>
              <span className="mt-5 inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-foreground-700 ring-1 ring-background-300">
                <i className="ri-price-tag-3-line"></i> {f.tag}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}